"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAnnounceCommissionsInputSchema = exports.APosMyEarningItemSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
// One product the employee can earn commission on (My Commission "Earning items")
exports.APosMyEarningItemSchema = zod_1.z.object({
    productId: id_schema_1.EntityIdSchema,
    productName: zod_1.z.string(),
    image: zod_1.z.string().optional().nullable(),
    commissionId: id_schema_1.EntityIdSchema,
    commissionName: zod_1.z.string(),
    commissionType: zod_1.z.enum(['flat_per_unit', 'percent_of_sale']),
    value: zod_1.z.number(),
    maxAmount: zod_1.z.number().optional().nullable(),
    scope: zod_1.z.object({
        total: zod_1.z.number().int().nonnegative(), // total variants of the product
        covered: zod_1.z.number().int().nonnegative(), // variants that carry this commission
        allVariants: zod_1.z.boolean(),
    }),
    endDate: zod_1.z.number().optional().nullable(), // epoch ms; null = no expiry
    estPerSale: zod_1.z.number().optional().nullable(), // preview $ for one sale (flat = value; percent = est from price)
    earned: zod_1.z.number().nonnegative().default(0), // employee's earned in the selected period
    unitsSold: zod_1.z.number().int().nonnegative().default(0),
    variants: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        variantName: zod_1.z.string(),
        price: zod_1.z.number().optional().nullable(),
        earned: zod_1.z.number().nonnegative().default(0),
        unitsSold: zod_1.z.number().int().nonnegative().default(0),
    })).default([]),
});
// Admin "Announce commissions to employees" request
exports.APosAnnounceCommissionsInputSchema = zod_1.z.object({
    commissionIds: zod_1.z.array(id_schema_1.EntityIdSchema).min(1),
    employeeIds: zod_1.z.array(id_schema_1.EntityIdSchema).min(1),
    message: zod_1.z.string().max(1000).optional(),
});
//# sourceMappingURL=commission-api.schema.js.map